import React, { useEffect, useState } from "react";
import {
  AgencySidePaitentEMERcontact,
  AgencySidePaitentEMERcontactUpdate,
  Deletecontact,
  Fetchemergencycontact,
} from "../../api/helper";
import DeleteModal from "../AgencyFlow/Components/DeleteModal";
import { ShowToast } from "../../helpers/ToastService";
import { useForm } from "react-hook-form";
import { Button, Card, CardContent, Label } from "./ReuseableComponent/alert";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const EmergencyContacts = ({ data, appointmentdetail, onComplete }) => {
  const [contactInfo, setContactInfo] = useState([]);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (formdata) => {
    const baseData = {
      contactName: formdata.contactName,
      phoneNumber: formdata.phoneNumber,
      relation: formdata.relation,
      email: formdata.email,
      patientId: data?.patientId,
      agencyId: appointmentdetail?.agencyId,
    };

    try {
      const response = await AgencySidePaitentEMERcontact(baseData);
      ShowToast(response?.data?.message || "Contact added successfully");
      onComplete?.(true);
      reset();
      getEmergencycontact();
    } catch (error) {
      console.log(error);
    }
  };
    const handleDownloadPDF = () => {
    if (!contactInfo || contactInfo.length === 0) {
      ShowToast("No emergency contact data found.");
      return;
    }
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Emergency Contacts", 14, 22);

    const rows = contactInfo.map((contact, index) => [
      index + 1,
      contact.contactName || "",
      contact.relation || "",
      contact.phoneNumber || "",
      contact.email || "",
      contact.isPrimary ? "Yes" : "No",
    ]);
    autoTable(doc, {
      startY: 30,
      head: [["#", "Name", "Relation", "Phone", "Email", "Primary"]],
      body: rows,
    });

    const filename = `Emergency_Contacts_${data?.patientName || "Patient"}.pdf`;
    doc.save(filename);
  };
  const getEmergencycontact = async () => {
    try {
      const Respo = await Fetchemergencycontact(
        appointmentdetail?.agencyId,
        data?.patientId
      );

      setContactInfo(Respo?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmergencycontact();
  }, []);
  const handleRemove = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
    const payload = {
      contactId: deleteId,
      agencyId: appointmentdetail?.agencyId,
      patientId: data?.patientId,
    };
    try {
      const respo = await Deletecontact(payload);
      ShowToast(respo?.data?.message);
      getEmergencycontact();
    } catch (error) {
      console.log(error);
    }
  };

  const UpdateisPrimary = async (contactId, currentIsPrimary) => {
    const isPrimary = !currentIsPrimary;
    const payload = {
      contactId,
      agencyId: appointmentdetail?.agencyId,
      patientId: data?.patientId,
      isPrimary,
    };
    try {
      const respo = await AgencySidePaitentEMERcontactUpdate(payload);
      onComplete?.(true);
      getEmergencycontact();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Card>
      <CardContent className="pt-6">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="contactName">Contact Name *</Label>
            <input
              id="contactName"
              {...register("contactName", { required: "Name is required" })}
              required
              className="verifyidentity-input"
            />
            {errors.contactName && (
              <p className="text-red-500 text-sm">
                {errors.contactName.message}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <Label htmlFor="relationship">Relationship *</Label>
            <input
              id="relationship"
              placeholder="e.g., Spouse, Parent, Sibling"
              {...register("relation", { required: "Relationship is required" })}
              required
              className="verifyidentity-input"
            />
            {errors.relation && (
              <p className="text-red-500 text-sm">
                {errors.relation.message}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <Label htmlFor="contactPhone">Phone Number *</Label>
            <input
              id="contactPhone"
              type="tel"
              {...register("phoneNumber", {
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Enter valid 10-digit number",
                },
              })}
              required
              className="verifyidentity-input"
            />
            {errors.phoneNumber && (
              <p className="text-red-500 text-sm">
                {errors.phoneNumber.message}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <Label htmlFor="contactEmail">Email Address *</Label>
            <input
              id="contactEmail"
              type="email"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                  message: "Invalid email address",
                },
              })}
              required
              className="verifyidentity-input"
            />
            {errors.email && (
              <p className="text-red-500 text-sm">{errors.email.message}</p>
            )}
          </div>

          <Button
            type="submit"
            className="w-full bg-[#BC9C22] hover:bg-[#9e7f1f]"
          >
            Save Emergency Contact
          </Button>
        </form>
        <table id="member-table">
          <thead>
            <tr>
              <th>Contact Name</th>
              <th>Phone Number</th>
              <th>Relation</th>
              <th>Email</th>
              <th>Action</th>
              <th>Primary</th>
            </tr>
          </thead>
          {contactInfo && contactInfo.length > 0 ? (
            contactInfo?.map((contact) => (
              <tr key={contact._id}>
                <td>{contact.contactName}</td>
                <td>{contact.phoneNumber}</td>
                <td>{contact.relation}</td>
                <td>{contact.email}</td>

                <td className="custom-action-td">
                  <div className="custom-dropdown">
                    <button className="custom-action-button">⋮ Actions</button>
                    <div className="custom-dropdown-menu">
                      <ul>
                        <li>
                          <button
                            className="custom-dropdown-item"
                            onClick={() => handleRemove(contact._id)}
                          >
                            Delete
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={contact?.isPrimary}
                    onChange={() =>
                      UpdateisPrimary(contact._id, contact.isPrimary)
                    }
                  />
                </td>
              </tr>
            ))
          ) : (
            <p style={{ textAlign: "left", marginTop: 10 }}>No Contact Found</p>
          )}
        </table>
        <Button
          style={{ marginTop: 10 }}
          className="w-full bg-[#BC9C22] hover:bg-[#9e7f1f]"
          onClick={handleDownloadPDF}
        >
          Download PDF
        </Button>
        {confirmdeletemodal && (
          <DeleteModal
            name="Emergency Contact"
            onClose={() => setconfirmdeletemodal(false)}
            onConfirm={confirmDelete}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default EmergencyContacts;
